import {useQuery} from '@tanstack/react-query';

import {getMappings, SPORT_CATEGORY_SLUGS} from '../api';
import {ApiSportsMappingsResponse, MappingKind} from '../api/types';

export const useGetMappings = (
  categorySlug: string | undefined,
  kind: MappingKind,
  entityId: string | undefined,
  searchQuery?: string,
  season?: string,
) => {
  const slug = categorySlug?.toLowerCase();
  // The matches endpoint requires a season, so hold the request until one is
  // picked instead of firing a request the backend would reject.
  const hasRequiredSeason = kind !== 'matches' || !!season;

  return useQuery<ApiSportsMappingsResponse>({
    queryKey: [
      'apiSportsMappings',
      kind,
      slug,
      entityId,
      searchQuery ?? '',
      season ?? '',
    ],
    queryFn: () => getMappings(slug!, kind, entityId!, searchQuery, season),
    enabled:
      !!slug &&
      !!entityId &&
      hasRequiredSeason &&
      SPORT_CATEGORY_SLUGS.includes(slug),
  });
};
